<template>
	<main id="pools">
		<form>
			<h2>{{currentSession.event && currentSession.event.name}}</h2>
			<i>{{prettyDate}}</i>
			<p><b>{{candidateInfos.name}}</b><br><i><span v-if="candidateInfos.startDate">Disponible le : {{candidateInfos.startDate}}</span><br>
			{{candidateInfos.mail}}</i></p>
			<h3>{{properties && getLabel(properties.title)}} :</h3>
			<ul>
				<li v-for="(value, key) in pools" class="pool" v-bind:class="value.value == true ? 'selected' : ''" v-on:click.self.prevent="checkPool">
					<input type="checkbox" v-bind:name="value.ref" v-bind:id="value.ref" v-model="value.value" v-on:change="isActive">
					<label class="poolLabel" v-bind:for="value.ref">{{value.label}}</label>
				</li>
			</ul>
			<div v-if="properties && properties.extraValue">
				<label for="extraValue">{{getLabel(properties.extraValue.label)}} : </label>
				<input type="text" v-model="extraValue">
			</div>
			<button v-on:click.self.stop.prevent="validateForm()" v-bind:class="buttonActive ? 'selected' : ''">Valider</button>
		</form>
	</main>
</template>

<script>
import libs from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

function checkForm(instance){
	let pools = instance.pools;
	for(let _i = 0; _i < pools.length; ++_i) {
		if(pools[_i].value == true) return true;
	}
	return instance.extraValue && instance.extraValue.length ? true : false;
}
export default {
	name: 'poolsTpl',
	data() {
		return {
			buttonActive : false,
			pools : [],
			extraValue : null
		}
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	computed : {
		candidateInfos : function(){
			let infos = this.currentSession.stepsResults && Object.keys(this.currentSession.stepsResults).find(e => e.indexOf('candidateTpl') > -1 && this.currentSession.stepsResults[e].firstName);
			if(!infos) infos = this.currentSession.stepsResults && Object.keys(this.currentSession.stepsResults).find(e => e.indexOf('candidateSelectionTpl') > -1 && this.currentSession.stepsResults[e].name);
			if(infos) infos = this.currentSession.stepsResults[infos];
			return {
				name : infos && ( infos.firstName ? (infos.firstName + ' ' + infos.lastName) : infos.name ),
				mail : infos && infos.mail,
				startDate : infos && infos.startDate && libs.prettyDate(this.lang, "digital", infos.startDate)
			};
		},
		prettyDate : function(){
			return libs.prettyDate(this.lang, 'text');
		}
	},
	methods : {
		validateForm : function() {
			if(!checkForm(this)) return;
			let pools = this.pools.filter(e => e.ref && e.value === true).map(e => e.ref);
			let payload = {pools};
			if(this.extraValue && this.properties && this.properties.extraValue && this.properties.extraValue.name) payload[this.properties.extraValue.name] = this.extraValue;
			this.$emit('validateStep', this.$options.name, payload);
		},
		isActive : function() {
			this.buttonActive = checkForm(this);
		},
		checkPool : function(element) {
			let target = element.target.firstChild.id;
			if(!target) return;
			for(let _i = 0; _i < this.pools.length; ++_i){
				if(this.pools[_i].ref == target) {
					if(this.pools[_i].value == true) this.pools[_i].value = false;
					else this.pools[_i].value = true;
					this.pools.splice(_i, 1, this.pools[_i]);
					this.buttonActive = checkForm(this);
					return;
				}
			}
		},
		loadPools : function() {
			let self = this;
			if(this.properties && Array.isArray(this.properties.pools) ) {
				this.pools = this.properties.pools.map( e => {return {label : e.label, ref : e.ref, value : '' }});
				this.$nextTick(function () {
					try{
						let form = this.$el.childNodes[0];
						let children = form.childNodes || [];
						let maxHeight = -1, lis = [], halfHeight;
						for (let _i = 0; _i < children.length; _i++) {
							if(children[_i].nodeName !== "UL") continue;
							let li = children[_i].childNodes;
							for (let _j = 0; _j < li.length; _j++) {
								if(li[_j].nodeName !== "LI") continue;
								lis.push(li[_j]);
								if(li[_j].offsetHeight > maxHeight) maxHeight = li[_j].offsetHeight;
							}
							break;
						}
						halfHeight = Math.floor(maxHeight / 2);
						lis.forEach(elem => {
							elem.style.height = maxHeight+'px';
							let children = elem.childNodes;
							for (let _i = 0; _i < children.length; _i++) {
								if(children[_i].nodeName !== "LABEL") continue;
								let childHalfHeight = Math.floor(children[_i].offsetHeight / 2);
								children[_i].style['margin-top'] = Math.abs(halfHeight - childHalfHeight)+'px'; //Remove padding
							}
						});
					}catch(e){console.log(e);}
					//Restore pool selection
					let keyRes = self.$options.name + '_' + self.templateIndex;
					let previousRes = self.currentSession.stepsResults && self.currentSession.stepsResults[keyRes] && self.currentSession.stepsResults[keyRes].pools;
					if(Array.isArray(previousRes)) {
						previousRes.forEach( grpId => {
							for(let _i = 0; _i < self.pools.length; ++_i){
								if(self.pools[_i].ref == grpId){
									self.pools[_i].value = true;
									self.pools.splice(_i, 1, self.pools[_i]);
									break;
								}
							}
						});
						self.isActive();
					}
				});
			}
		},
		getLabel : componentTools.getLabel
	},
	watch : {
		properties : function(){this.loadPools();},
		extraValue : function(){this.isActive();}
	},
	created : function(){
		componentTools.created.call(this);
		this.loadPools();
	}
};
</script>

<style lang="less">
@import '../assets/less/conf.import.less';
#pools input[type="checkbox"]{
	display: none;
}
#pools ul{
	padding-bottom: 5%;
	li {
		display: inline-block;
		width: 106px;
		user-select : none;
		vertical-align: middle;
		margin-top: @margin;
		margin-left: @margin;
		margin-right: @margin;
		border-radius: 5px;
		border: 1px solid @cGrey_Light_3;
		cursor: pointer;
		z-index: 1;
	}
	.poolLabel{
		width: 100%;
		display: inline-block;
		word-break: break-word;
		margin : @margin auto;
		font-size: 12px;
		z-index: 2;
		pointer-events: none;
	}
}


</style>



// WEBPACK FOOTER //
// src/components/pools.vue